import React, { FC, useState }                        from "react";
import { useDispatch, useSelector }                   from "react-redux";
import { Button, Checkbox, Form, Icon, Modal, Table } from "semantic-ui-react";
import GetCustomersAllHaveEmail
                                                      from "../../../../../application/usecase/customer/GetCustomersAllHaveEmail";
import GetCustomersHaveEmail
                                                      from "../../../../../application/usecase/customer/GetCustomersHaveEmail";
import RegisterMailGroup
                                                      from "../../../../../application/usecase/mail/group/RegisterMailGroup";
import CustomerSearchValue
                                                      from "../../../../../domain/customer/criteria/CustomerSearchValue";
import Customers                                      from "../../../../../domain/customer/Customers";
import CurrentPage                                    from "../../../../../domain/fundamentals/pagination/CurrentPage";
import MailGroup                                      from "../../../../../domain/mail/group/MailGroup";
import MailGroupName                                  from "../../../../../domain/mail/group/MailGroupName";
import MailGroupRepository                            from "../../../../../domain/mail/group/MailGroupRepository";
import { ResKaState }                                 from "../../../../../index";
import MailGroupDataSource
                                                      from "../../../../../infrastructure/datasource/mail/group/MailGroupDataSource";
import BottomSection                                  from "../../../common/layout/BottomSection";
import ListTotalCount                                 from "../../../common/layout/ListTotalCount";
import TopSection                                     from "../../../common/layout/TopSection";
import ValidatorMessage                               from "../../../message/ValidatorMessage";
import MailGroupCustomersPagination                   from "./MailGroupCustomersPagination";
import MailGroupCustomersSearchBox                    from "./MailGroupCustomersSearchBox";

const MailGroupRegisterFormButton: FC = () => {
  const [open, setOpen] = useState(false);
  const mailGroup: MailGroup = useSelector((state: ResKaState) => state.mailGroup);
  const customers: Customers = useSelector((state: ResKaState) => state.customers);
  const repository: MailGroupRepository = new MailGroupDataSource(useDispatch());
  const registerMailGroup: RegisterMailGroup = new RegisterMailGroup(useDispatch());
  const getCustomersHaveEmail: GetCustomersHaveEmail = new GetCustomersHaveEmail(useDispatch());
  const getCustomersAllHaveEmail: GetCustomersAllHaveEmail = new GetCustomersAllHaveEmail(useDispatch());

  return (
    <>
      <Button
        icon
        labelPosition="left"
        onClick={ () => {
          getCustomersHaveEmail.execute(new CurrentPage(), new CustomerSearchValue());
          repository.setMailGroup(new MailGroup());
          setOpen(true);
        } }
      >
        <Icon name="plus"/>
        メールグループを新しく作成する
      </Button>

      <Modal
        open={ open }
      >
        <Modal.Header>メールグループを作成</Modal.Header>

        <Modal.Content>
          <TopSection>
            <Form>
              <Form.Field required>
                <label>メールグループ名</label>
                <Form.Input
                  placeholder="用途などわかりやすい名称を入力してください。"
                  defaultValue={ mailGroup.name.value }
                  onChange={ (event, data) => repository.setMailGroupName(new MailGroupName(data.value)) }
                />
                <ValidatorMessage target="name"/>
              </Form.Field>
            </Form>
          </TopSection>

          <TopSection>
            <MailGroupCustomersSearchBox/>
          </TopSection>

          <TopSection>
            <Button onClick={ () => getCustomersAllHaveEmail.execute(customers.search) }>全選択</Button>
            <Button onClick={ () => repository.allUnSelectedCustomer() }>全解除</Button>
          </TopSection>

          {
            customers.isEmpty() && customers.search.value
              ?
              <>
                <p>検索結果がありません。</p>
              </>
              :
              customers.isEmpty()
                ?
                <>
                  メールアドレスが登録されている顧客がありません。
                </>
                :
                <>
                  <ListTotalCount>{ customers.count.toString() }</ListTotalCount>
                  <Table
                    striped
                    selectable
                  >
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>選択</Table.HeaderCell>
                        <Table.HeaderCell>顧客番号</Table.HeaderCell>
                        <Table.HeaderCell>顧客氏名</Table.HeaderCell>
                        <Table.HeaderCell>都道府県</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {
                        customers.toList().map(customer => (
                          <Table.Row
                            onClick={ () => mailGroup.customerIds.has(customer.id) ? repository.removeCustomerId(customer.id) : repository.addCustomerId(customer.id) }
                          >
                            <Table.Cell>
                              <Checkbox
                                checked={ mailGroup.customerIds.has(customer.id) }
                                onChange={ () => mailGroup.customerIds.has(customer.id) ? repository.removeCustomerId(customer.id) : repository.addCustomerId(customer.id) }
                              />
                            </Table.Cell>
                            <Table.Cell>
                              { customer.detail.number.value }
                            </Table.Cell>
                            <Table.Cell>
                              { `${ customer.detail.name.lastName.value } ${ customer.detail.name.firstName.value }` }
                            </Table.Cell>
                            <Table.Cell>
                              { customer.address.prefecture.value }
                            </Table.Cell>
                          </Table.Row>
                        ))
                      }
                    </Table.Body>
                  </Table>

                  <BottomSection>
                    <MailGroupCustomersPagination/>
                  </BottomSection>
                </>
          }
        </Modal.Content>

        <Modal.Actions>
          <Button
            icon
            labelPosition="left"
            positive
            onClick={ () => registerMailGroup.execute(mailGroup, setOpen) }
          >
            <Icon name="save"/>
            保存する
          </Button>

          <Button onClick={ () => setOpen(false) }>閉じる</Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default MailGroupRegisterFormButton;
